import { DataBean } from "../../DataBean";


export class HealthScope extends DataBean {

    public async getHealthScopeCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthScopeCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }
}